import React from "react";

const colorMap = {
  emerald: "bg-indigo-100 text-indigo-700",
  blue: "bg-blue-100 text-blue-700",
  violet: "bg-indigo-100 text-indigo-700",
  amber: "bg-amber-100 text-amber-700",
  rose: "bg-rose-100 text-rose-700",
  slate: "bg-slate-200 text-slate-700",
};

export const Avatar = ({ person, size = 36, ring = false, online = false }) => {
  const initials =
    person.initials ||
    person.name
      .split(" ")
      .map((p) => p[0])
      .slice(0, 2)
      .join("");

  return (
    <div
      className="relative inline-flex shrink-0"
      style={{ width: size, height: size }}
      data-testid={`avatar-${person.id || person.name}`}
    >
      <div
        className={`rounded-full overflow-hidden flex items-center justify-center font-semibold ${
          colorMap[person.color] || colorMap.slate
        } ${ring ? "ring-2 ring-white" : ""}`}
        style={{ width: size, height: size, fontSize: size * 0.36 }}
      >
        {person.avatar ? (
          <img
            src={person.avatar}
            alt={person.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <span>{initials}</span>
        )}
      </div>
      {online && (
        <span
          className="absolute bottom-0 right-0 block rounded-full bg-indigo-500 ring-2 ring-white"
          style={{ width: size * 0.28, height: size * 0.28 }}
          aria-hidden
        />
      )}
    </div>
  );
};

export const AvatarStack = ({ people, max = 4, size = 32 }) => {
  const visible = people.slice(0, max);
  const extra = people.length - visible.length;
  return (
    <div className="flex items-center" data-testid="participant-avatar-stack">
      {visible.map((p, i) => (
        <div key={p.id} style={{ marginLeft: i === 0 ? 0 : -10 }}>
          <Avatar person={p} size={size} ring online={p.online} />
        </div>
      ))}
      {extra > 0 && (
        <div
          className="rounded-full bg-slate-900 text-white flex items-center justify-center text-[11px] font-semibold ring-2 ring-white"
          style={{ width: size, height: size, marginLeft: -10 }}
        >
          +{extra}
        </div>
      )}
    </div>
  );
};
